import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { PageContainer } from 'src/components/CustomersBar/CustomerTab/ResponsibleGamblingTab/ResponsibleGamblingTabs.style';
import { Badge } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CustomerSummaryTab.style';
import { Button } from 'src/domains/common/components/button/button';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { useAppStateContext } from 'src/AppState/AppState';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';
import { convertGamstopStatusToBadgeType } from './utils';
import { GamstopState } from './Gamstop.state';

interface GamstopPropsType {
    customerId: number;
}

const handleAuditClick = (routerBackoffice: RouterBackoffice): void => {
    routerBackoffice.setParamInNamespace('customers', 'audits', 'gamstopAudit');
};

export const GamstopTab = observer('GamstopTab', ({ customerId }: GamstopPropsType) => {
    const { common, routerBackoffice } = useAppStateContext();

    const [state] = useState(() => new GamstopState(customerId, common));
    const { complianceNew } = ConfigState.get(common).config;

    if (state.gamstopUserStore.isLoading) {
        return (
            <LoadingV2
                dataTest='gamstop-loading'
                title='Loading Gamstop data...'
            />
        );
    }

    const badgeType = convertGamstopStatusToBadgeType(state.gamstopUserStore.status);
    const badgeLabel = state.gamstopUserStore.status === 'P' ? 'PP' : state.gamstopUserStore.status;

    return (
        <PageContainer>
            <header className='flex items-center justify-between flex-[0_0_36px]'>
                <h2
                    className='header text-foreground'
                    data-test='page-title'
                >
                    Gamstop
                </h2>
                <div className='flex items-center gap-2'>
                    {complianceNew && (
                        <Button
                            onClick={() => handleAuditClick(routerBackoffice)}
                            variant='secondary'
                            dataTest='gamstop-audit-button'
                        >
                            Gamstop Audit
                        </Button>
                    )}
                </div>
            </header>

            <div className='mb-10'>
                <div className='flex items-center'>
                    <h4
                        className='flex items-center gap-2 mt-0 mb-0'
                        data-test='status'
                    >
                        <span>Status:</span>
                        <Badge
                            badgeType={badgeType}
                            data-test='gamstop-status'
                        >
                            {badgeLabel}
                        </Badge>
                    </h4>
                </div>

                <div className='grid grid-cols-2 bg-gray-50 mt-12 rounded-xl border border-gray-200 overflow-hidden'>
                    <div
                        className='p-5 border-r border-gray-200'
                        data-test='gamstop-last-status-change'
                    >
                        <div className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5'>
                            Last status change
                        </div>
                        <div className='flex items-center gap-1.5'>
                            <strong className='font-bold text-base text-gray-900'>
                                {state.gamstopUserStore.updatedAt}
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
        </PageContainer>
    );
});
